import { isPercent } from "@amcharts/amcharts4/core";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { vignettePreview_template } from "./vignettePreview_template";

declare var ko: any;

export class configPromotionsView_template extends vnTemplate {

    protected vignettePreview: vignettePreview_template;

    protected getTemplateHtml(): string {
        return (`

            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickEdit   }" class="btn icon light i-edit" type="button">Edit</button>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>ID</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: id"></span>
                                </dd>
                                <dt>
                                    <span>Name</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: name"></span>
                                </dd>

                                <dt>
                                    <span>Is Available For Use</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isAvailable"></span>
                                </dd>

                                <dt>
                                    <span>Login User Condition</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isLoginUser"></span>
                                </dd>

                                <dt>
                                    <span>Premium User Condition</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isPremiumUser"></span>
                                </dd>

                                <dt>
                                    <span>List User Condition</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: has5ListItemsOrMore"></span>
                                </dd>
                                <dt>
                                    <span>Preset</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: preset"></span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>

                <div class="w-form-body" data-bind="visible: preset() == ''">
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">HTML</strong>
                        <div class="form-group">
                            <label for="" class="form-label">HTML</label>
                            <pre style="height: 300px" id="htmlEditor" data-bind="text: html"></pre>
                        </div>
                    </div>
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">CSS</strong>
                        <div class="form-group">
                            <label for="" class="form-label">CSS</label>
                            <pre style="height: 300px" id="cssEditor" data-bind="text: css"></pre>
                        </div>
                    </div>
                </div>

                <div class="form-body" data-bind="visible: preset() == ''">
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group">
                            `+ this.vignettePreview.getHtmlBuild() +`
                        </div>
                    </div>
                </div>

            </div>
        `);
    }

    protected getTemplateName(): string {

        return "configPromotionsView_template";
    }

    protected buildViewModel(): any {

        let self = this
        return {
            id: ko.observable("")
            , name: ko.observable("")
            , isAvailable: ko.observable("")
            , isLoginUser: ko.observable("")
            , isPremiumUser: ko.observable("")
            , has5ListItemsOrMore: ko.observable("")
            , html: ko.observable("")
            , css: ko.observable("")
            , preset: ko.observable("")
            , dateCreated: ko.observable("")
            , dateUpdated: ko.observable("")
            , zones: ko.observableArray([])
            , permissions: ko.observableArray(this.initPermissions(['config_promotion']))
            , onClickEdit: function (data, event) {
                self.onClickEdit(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }


    protected initPartial(): void {

        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.caller);
        this.vignettePreview.setShowKeys(true);
    }

    public setPromotion(data) {

        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().name(data.name);
        this.getTemplateViewModel().isAvailable(data.isAvailable ? "Yes" : "No");
        this.getTemplateViewModel().isLoginUser(data.isLoginUser == '1' ? "Is Logged In" : (data.isLoginUser == '0') ? "Is Not Logged In" : "Not Applied");
        this.getTemplateViewModel().isPremiumUser(data.isPremiumUser == '1' ? "Is Premium" : (data.isPremiumUser == '0') ? "Is Not Premium" : "Not Applied");
        this.getTemplateViewModel().has5ListItemsOrMore(data.has5ListItemsOrMore == '1' ? "Has 5 Or More Items in Lists" : (data.has5ListItemsOrMore == '0') ? "Has Less Than 5 Items in Lists" : "Not Applied");
        this.getTemplateViewModel().html(data.html);
        this.getTemplateViewModel().css(data.css);
        this.getTemplateViewModel().preset(data.preset ? data.preset.name : '');
        this.getTemplateViewModel().dateCreated(data.dateCreated);
        this.getTemplateViewModel().dateUpdated(data.dateUpdated);

        //set vignette
        this.vignettePreview.setHtml(data.html);
        this.vignettePreview.setCss(data.css);
    }

    protected setZones(zones) {

        this.getTemplateViewModel().zones(zones);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    protected onClickEdit(id: any): any {

        this.caller.onClickEdit(id)
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/configPromotionsView_template.ts